module.exports = __webpack_public_path__ + "static/favicon-f4bed58d65257e9cb2f4232f52d02f70.jpg";